import { useState } from "react";
import Translator from "../services/Translator";
import {config} from "../config";

const PIN_KEY = "pin";

export default function Settings({lang, user, screen}: any) {
    const [pin, setPin] = useState("");
    const [confirm, setConfirm] = useState("");
    const [message, setMessage] = useState<{type: string, text: string} | null>(null);
    const [hasPin, setHasPin] = useState(() => localStorage.getItem(PIN_KEY) !== null);

    const digitsOnly = (value: string) => value.replace(/\D/g, "").slice(0, config.pinLength);

    const savePin = () => {
        if (pin.length < config.pinLength) {
            setMessage({type: 'error', text: Translator.trans(lang, 'settings.security.pin.error.length')});
            return;
        }
        if (pin !== confirm) {
            setMessage({type: 'error', text: Translator.trans(lang, 'settings.security.pin.error.match')});
            return;
        }
        localStorage.setItem(PIN_KEY, pin);
        setHasPin(true);
        setPin("");
        setConfirm("");
        setMessage({type: 'success', text: Translator.trans(lang, 'settings.security.pin.saved')});
    };

    const removePin = () => {
        localStorage.removeItem(PIN_KEY);
        setHasPin(false);
        setPin("");
        setConfirm("");
        setMessage({type: 'success', text: Translator.trans(lang, 'settings.security.pin.removed')});
    };

    return (
        <div id="settings" style={{display: user === null || screen !== 'settings' ? 'none' : 'block'}}>
            <div className="container">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            {Translator.trans(lang, 'settings.security.name')}
                        </div>

                        <div className="card-body">
                            {message && (
                                <div className={`alert alert-${message.type === 'error' ? 'danger' : 'success'} mb-0`}>
                                    {message.text}
                                </div>
                            )}

                            <div className="mb-3">
                                <label className="form-label">
                                    {Translator.trans(lang, 'settings.security.pin.new')}
                                </label>
                                <input
                                    type="password"
                                    inputMode="numeric"
                                    className="form-control"
                                    value={pin}
                                    onChange={(e) => {setPin(digitsOnly(e.target.value)); setMessage(null);}}
                                    placeholder=""
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">
                                    {Translator.trans(lang, 'settings.security.pin.confirm')}
                                </label>
                                <input
                                    type="password"
                                    inputMode="numeric"
                                    className="form-control"
                                    value={confirm}
                                    onChange={(e) => {setConfirm(digitsOnly(e.target.value)); setMessage(null);}}
                                    placeholder=""
                                />
                            </div>

                            <button
                                className="btn btn-primary"
                                onClick={savePin}
                                disabled={pin.length < config.pinLength || confirm.length < config.pinLength}
                            >
                                {Translator.trans(lang, 'common.save')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}